declare namespace $ {

	type $mol_textarea__value_shm_projects_goal_request_1 = $mol_type_enforce<
		ReturnType< $shm_projects_goal_request['value'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__event_shm_projects_goal_request_2 = $mol_type_enforce<
		({ 
			paste( next?: ReturnType< $shm_projects_goal_request['image_paste'] > ): ReturnType< $shm_projects_goal_request['image_paste'] >,
		})  & ReturnType< $mol_textarea['event'] >
		,
		ReturnType< $mol_textarea['event'] >
	>
	type $mol_image__uri_shm_projects_goal_request_3 = $mol_type_enforce<
		ReturnType< $shm_projects_goal_request['attachment_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_text__text_shm_projects_goal_request_4 = $mol_type_enforce<
		ReturnType< $shm_projects_goal_request['attachment_name'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_button_minor__title_shm_projects_goal_request_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__sub_shm_projects_goal_request_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_projects_goal_request_7 = $mol_type_enforce<
		ReturnType< $shm_projects_goal_request['attachment_remove'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_form_field__name_shm_projects_goal_request_8 = $mol_type_enforce<
		ReturnType< $shm_projects_goal_request['label'] >
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__attr_shm_projects_goal_request_9 = $mol_type_enforce<
		({ 
			'shm_projects_goal_requirements': ReturnType< $shm_projects_goal_request['requirements'] >,
			'shm_projects_goal_refinement': ReturnType< $shm_projects_goal_request['refinement'] >,
		})  & ReturnType< $mol_form_field['attr'] >
		,
		ReturnType< $mol_form_field['attr'] >
	>
	type $mol_form_field__Content_shm_projects_goal_request_10 = $mol_type_enforce<
		ReturnType< $shm_projects_goal_request['Input'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_list__rows_shm_projects_goal_request_11 = $mol_type_enforce<
		ReturnType< $shm_projects_goal_request['attachment_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_projects_goal_request_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_projects_goal_request extends $mol_view {
		request_content( ): readonly(any)[]
		label( ): string
		requirements( ): boolean
		refinement( ): boolean
		image_paste( next?: any ): any
		Input( ): $mol_textarea
		attachment_rows( ): readonly(any)[]
		drag_active( next?: boolean ): boolean
		drag_enter( next?: any ): any
		drag_over( next?: any ): any
		drag_leave( next?: any ): any
		file_drop( next?: any ): any
		attachment_uri( id: any): string
		Attachment_image( id: any): $mol_image
		attachment_name( id: any): string
		Attachment_name( id: any): $mol_text
		Attachment_remove_icon( id: any): $mol_icon_close
		attachment_remove( id: any, next?: any ): any
		Attachment_remove( id: any): $mol_button_minor
		value( next?: string ): string
		attachments( next?: readonly($shm_projects_goal_attachment)[] ): readonly($shm_projects_goal_attachment)[]
		attachments_payload( ): readonly($shm_projects_goal_attachment)[]
		after( ): readonly(any)[]
		sub( ): ReturnType< $shm_projects_goal_request['request_content'] >
		Field( ): $mol_form_field
		Attachments( ): $mol_list
		attr( ): ({ 
			'shm_projects_goal_request_drag': ReturnType< $shm_projects_goal_request['drag_active'] >,
		})  & ReturnType< $mol_view['attr'] >
		event( ): ({ 
			dragenter( next?: ReturnType< $shm_projects_goal_request['drag_enter'] > ): ReturnType< $shm_projects_goal_request['drag_enter'] >,
			dragover( next?: ReturnType< $shm_projects_goal_request['drag_over'] > ): ReturnType< $shm_projects_goal_request['drag_over'] >,
			dragleave( next?: ReturnType< $shm_projects_goal_request['drag_leave'] > ): ReturnType< $shm_projects_goal_request['drag_leave'] >,
			drop( next?: ReturnType< $shm_projects_goal_request['file_drop'] > ): ReturnType< $shm_projects_goal_request['file_drop'] >,
		})  & ReturnType< $mol_view['event'] >
		Attachment( id: any): $mol_view
	}
	
}

//# sourceMappingURL=request.view.tree.d.ts.map